import React from "react";
import { FacebookIcon, InstagramIcon, LinkedinIcon, TwitterIcon } from "@/dmr/common/SvgIcons";
import { getValidUrl } from "@/utils/helper/string";

interface SocialLinksProps {
  social?: {
    instagram?: string;
    facebook?: string;
    twitter?: string;
    linkedin?: string;
  };
}

export const SocialLinks: React.FC<SocialLinksProps> = ({ social }) => {
  if (!social) return null;
  return (
    <>
      {social.instagram ? (
        <a href={getValidUrl(social.instagram)} target="_blank" rel="noopener noreferrer">
          <InstagramIcon />
        </a>
      ) : null}
      {social.facebook ? (
        <a href={getValidUrl(social.facebook)} target="_blank" rel="noopener noreferrer">
          <FacebookIcon />
        </a>
      ) : null}
      {social.twitter ? (
        <a href={getValidUrl(social.twitter)} target="_blank" rel="noopener noreferrer">
          <TwitterIcon />
        </a>
      ) : null}
      {social.linkedin ? (
        <a href={getValidUrl(social.linkedin)} target="_blank" rel="noopener noreferrer">
          <LinkedinIcon />
        </a>
      ) : null}
    </>
  );
};
